import {Tr} from "@/i18n/i18n";
import Scene = Phaser.Scene;
import {Keys} from "@/constants/key";
import TextUtils from "@/utils/text-utils";
import Container = Phaser.GameObjects.Container;
import {ArtifactBasePanel} from "@/scenes.ui/artifact-base-panel";
import {SquareButton} from "@/scenes.ui/square-button";
import {Fonts} from "@/constants/font";
import CU from "@/utils/c-u";

export class SlotInfoPanel extends ArtifactBasePanel {

    constructor(scene: Scene, canvas: HTMLCanvasElement, titleTxt: string, mainTxt: string,
                slotX: number, slotY: number, container: Container) {
        super(scene, canvas, slotX, slotY, container);
        this.setScale(1 / CU.S, 1 / CU.S);

        const title = TextUtils.addTextByFamily(this.scene, titleTxt, 0, -282, '#ffffff', 16,
            'normal', 420, Fonts.ARIAL_MT)
            .setOrigin(0.5, 0.5);

        let mainText = TextUtils.addTextByFamily(scene, mainTxt,
            0, -80, '#fffce9', 18, 'normal', 200, Fonts.ARIAL_MT);

        let okButton = new SquareButton(this.scene, 0, 160, 0,
            Keys.UI_ART_BROWN_BUTTON, Keys.ATLAS_PROFILE, Keys.UI_GOLDEN_CHECK, Tr('zakrit'), false);

        this.add(okButton);

        okButton.setCallback(() => {
            if (this.isOnTop()) {
                this.close();
            }
        });

        this.add([title, mainText, okButton]);
    }
}
